import React from 'react';
import { ArrowUpRight } from 'lucide-react';
interface FooterProps {
  currentPage: string;
  onNavigate: (page: string) => void;
}
export function Footer({
  currentPage,
  onNavigate
}: FooterProps) {
  const footerFont = "'Helvetica Neue', Helvetica, Arial, sans-serif";
  return <footer className="bg-white px-4 sm:px-6 md:px-12 pt-12 md:pt-20 pb-8" style={{
    fontFamily: footerFont
  }} data-id="element-15">
      {/* Top section - 4 columns on desktop, 1 on mobile */}
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-8 items-start" data-id="element-16">
        {/* Say Hello */}
        <div data-id="element-17">
          <p className="text-[12px] text-gray-400 mb-3" data-id="element-18">Say "Hello":</p>
          <a href="mailto:annissa@safetywing.com" className="text-[14px] text-black hover:opacity-60 transition-opacity" data-id="element-19">
            annissa@safetywing.com
          </a>
        </div>

        {/* Navigate */}
        <div data-id="element-20">
          <p className="text-[12px] text-gray-400 mb-3" data-id="element-21">Navigate:</p>
          <div className="flex flex-col gap-1.5 items-start" data-id="element-22">
            <button onClick={() => onNavigate('home')} className={`text-[14px] tracking-[0.05em] hover:opacity-60 transition-opacity ${currentPage === 'home' ? 'text-gray-400' : 'text-black'}`} data-id="element-23">
              HOME
            </button>
            <button onClick={() => onNavigate('about')} className={`text-[14px] tracking-[0.05em] hover:opacity-60 transition-opacity ${currentPage === 'about' ? 'text-gray-400' : 'text-black'}`} data-id="element-24">
              ABOUT
            </button>
            <button onClick={() => onNavigate('dinners')} className={`text-[14px] tracking-[0.05em] hover:opacity-60 transition-opacity ${currentPage === 'dinners' ? 'text-gray-400' : 'text-black'}`} data-id="element-25">
              DINNERS
            </button>
            <a href="https://www.notion.so/safetywing/Nomad-Citizen-Product-Info-1ba73e1ca3428079bd3fe36d52eb2161" target="_blank" rel="noopener noreferrer" className="text-[14px] text-black tracking-[0.05em] hover:opacity-60 transition-opacity" data-id="element-26">
              MANIFESTO
            </a>
            <a href="https://safetywing.com/nomad-citizen" target="_blank" rel="noopener noreferrer" className="text-[14px] text-black tracking-[0.05em] hover:opacity-60 transition-opacity" data-id="element-27">
              MEMBERSHIP
            </a>
          </div>
        </div>

        {/* Thank you message */}
        <div className="sm:col-span-2 md:col-span-1" data-id="element-28">
          <p className="text-[18px] md:text-[22px] leading-[1.35] font-normal text-black" data-id="element-29">
            Thank you for stopping by our table. Welcome, grab a seat, stay
            awhile.
          </p>
        </div>

        {/* Connect */}
        <div data-id="element-30">
          <p className="text-[12px] text-gray-400 mb-3" data-id="element-31">Connect:</p>
          <div className="flex items-center gap-6" data-id="element-32">
            <a href="https://www.instagram.com/wearepoststrangers/" target="_blank" rel="noopener noreferrer" className="flex items-center text-[13px] text-black hover:opacity-60 transition-opacity" data-id="element-33">
              Instagram <ArrowUpRight className="ml-1 w-3.5 h-3.5" data-id="element-34" />
            </a>
            <a href="#" className="flex items-center text-[13px] text-black hover:opacity-60 transition-opacity" data-id="element-35">
              Whatsapp <ArrowUpRight className="ml-1 w-3.5 h-3.5" data-id="element-36" />
            </a>
          </div>
        </div>
      </div>

      {/* Large typography section */}
      <div className="flex items-end mt-12 md:mt-16 mb-8" data-id="element-37">
        <span className="text-[60px] sm:text-[80px] md:text-[100px] font-black leading-[0.85] tracking-tight text-black" data-id="element-38">
          P.
        </span>
        <span className="text-[18px] sm:text-[22px] md:text-[26px] text-gray-400 mx-2 md:mx-4 mb-2 md:mb-3" data-id="element-39">
          +
        </span>
        <span className="text-[60px] sm:text-[80px] md:text-[100px] font-black leading-[0.85] tracking-tight text-black" data-id="element-40">
          S.
        </span>
        <span className="text-[18px] sm:text-[22px] md:text-[26px] text-gray-400 ml-auto mb-2 md:mb-3" data-id="element-41">
          +
        </span>
      </div>

      {/* Bottom bar */}
      <div className="border-t border-black/10 pt-5" data-id="element-42">
        <p className="text-[12px] font-medium text-black" data-id="element-43">© 2026</p>
      </div>
    </footer>;
}